import { createBlock } from 'factories/block';
import { InteractionProps, repeat } from './interaction';
import { createLayout } from 'factories/layout';
import { createFeedbackBlock } from './feedback';
import { colors } from 'styles/variables';
import { Block, cloneBlock, Blocks } from '@chameleoncreator/creator-app';
import { flatten } from 'factories/utils';
import { createContinueBtn } from './continueBtn';
import { createEditableBtn } from './editableBtn';
import { createModalWithEditableBtn } from './modalWithEditableBtn';
import { createMediaBlock } from './media';
import Media_default from 'assets/Media_default.svg';

const { lPink, lGrey0, lGrey1, lGrey2 } = colors;

export type DragAndDropInteractionProps = InteractionProps & {
  answerCount: number;
};

const createDragAndDropElement = () => {
  return createBlock(
    'DragAndDropElement',
    [
      createBlock(
        'Drag',
        [
          createMediaBlock({
            src: Media_default,
            child: 1,
          }),
        ],
        {
          props: {
            type: 'Drag',
          },
          meta: {
            subType: 'Drag',
          },
        }
      ),
      createBlock(
        'Drop',
        [
          createMediaBlock({
            src: Media_default,
            child: 0,
          }),
        ],
        {
          props: {
            type: 'Drop',
          },
          meta: {
            subType: 'Drop',
          },
        }
      ),
      createFeedbackBlock({}),
    ],
    {
      props: {
        type: 'DragAndDropElement',
      },
      meta: {
        subType: 'DragAndDropElement',
      },
    }
  );
};

export const createDragAndDropBlock = (count: number) => {
  return createBlock('DragAndDrop', [
    createEditableBtn({ label: 'SUBMIT' }),
    createModalWithEditableBtn({}),
    ...repeat(() => createDragAndDropElement(), count),
  ]);
};

const contentForColumn = (count: number) => (i: number) => {
  return [() => createBlock('Text'), () => createDragAndDropBlock(count)][i];
};

export const addDragAndDropOption = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  if (block.type === 'DragAndDrop') {
    const dragAndDropOptionBlock = createDragAndDropElement();

    const dragAndDropOptionBlockRef = {
      id: dragAndDropOptionBlock.id,
      type: 'Ref',
    };
    const [newBlocks] = flatten(dragAndDropOptionBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(
      position,
      0,
      dragAndDropOptionBlockRef
    );

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

export const removeDragAndDropOption = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  if (block.type === 'DragAndDrop') {

    const dragAndDropOptionBlock = createDragAndDropElement();

    const [newBlocks] = flatten(dragAndDropOptionBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(position, 1);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

export const createDragAndDropInteractionBlock = (
  props: DragAndDropInteractionProps
) => {
  const {
    panelBackground = '#fff' || lPink,
    panelBackgroundDragging = lGrey0,
    textColorDragging = '#fff',
    dropZoneColor = lGrey1,
    baseColor = lGrey2,
    numberOfAttempts = 1,
    lockDown = 0,
    score = false,
    style,
  } = props as any;

  return createBlock(
    'Interaction',
    [
      createLayout(
        contentForColumn(props.answerCount),
        0,
        true
      ),
      createFeedbackBlock({}),
      createBlock('SingleColumnLayout', [
        createBlock(
          'Column',
          [
            createContinueBtn(style),
          ],
          {
            props: {
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              flexWrap: 'wrap',
            },
            meta: {
              subType: 'ButtonBlock',
            },
          }
        ),
      ]),
    ],
    {
      props: {
        name: props.name,
        style: props.style,
        panelBackground,
        panelBackgroundDragging,
        textColorDragging,
        dropZoneColor,
        baseColor,
        numberOfAttempts,
        lockDown,
        score,
      },
      meta: {
        subType: 'DragAndDrop',
        layout: 'OneColumnReversed',
      },
    }
  );
};

export const create = createDragAndDropInteractionBlock;
export const interactionConfig = {};
